import { useValidations } from "@sttedra_ui/framework";

const { required } = useValidations();

export default function () {
  return {
    items: [
      {
        field: "email",
        label: "Email",
        value: null,
        rules: { required },
        classObj: ["col-12"],
      },
      {
        field: "contrasena",
        label: "Contraseña",
        type: "Password",
        value: null,
        rules: { required },
        classObj: ["col-12"],
        properties: {
          toggleMask: true,
          feedback: false,
        },
      },
    ],
  };
}
